<template>
  <fieldset class="theme-switcher-main theme-switcher fadeInLeft">

    <input v-for="(theme, index) in themeColor" :key = "index" :class="['theme-switcher__radio', theme.class]"
           data-theme
           type="radio"
           name="color-scheme"
           :value="theme.color"
           :aria-label="theme.area"
           @click = "getTheme(theme.color)"
           :checked="theme.checked"
    >
      </fieldset>

</template>

<script>
export default {
  data()
    {
      return {
        themeColor :
            [
              {
                color : "brown",
                area  : "коричневая",
                class: "theme-switcher__radio_brown",
                checked: true

              },
              {
                color : "green",
                area  : "зеленая",
                class: "theme-switcher__radio_green",
                checked : false

              }

            ],
        currentTheme: localStorage.getItem('color-scheme'),

      };
    },
  name    : "SwitherTheme",

  methods : {
    getTheme(color)
      {
        // const switcherElements=document.querySelectorAll(".theme-switcher__radio");
        // switcherElements.forEach(( element ) =>
        // {
        //   element.addEventListener("click", ( event ) =>
        //   {
        //     console.log(event.target.value);
        //     //this.filter = event.target.value;
        //
        //   });
        // });
        //console.log('this.currentTheme');

        this.currentTheme = color;
        this.$emit('change-theme', color);
        //window.initUI();
      },
    // mounted() {
    //   console.log('mounted vue');
    //   window.initUI();
    //
    // },


  }
};
</script>

<style scoped>

</style>